import {Key} from "./Key";

export class IdKey extends Key{
    constructor(id:string){
        super({id:id});
    }

    public GetId():string{
        return this.value['id'];
    }
}


// WEBPACK FOOTER //
// C:/Users/Benoit/WebstormProjects/schiltz/server/src/typescript-plugin/entities/IdKey.ts